<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card-content">
        <form>
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        label="Marca"
                        v-model="car.info.make">
              </fg-input>
            </div>
            <div class="col-md-6">
            <fg-input type="text"
                      label="Modelo"
                      v-model="car.info.model">
            </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <fg-input type="text"
                        label="Dominio"
                        :disabled="true"
                        v-model="car.info.domain">
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input-validate type="text"
                                  validations="numeric"
                                  name="año"
                                  label="Año"
                                  delay="0"
                                  :disabled="true"
                                  @input-changed="input_changed"
                                  v-model="car.info.year">
              </fg-input-validate>
            </div>
            <div class="col-md-4">
              <fg-input type="text"
                        label="Color"
                        v-model="car.info.color">
              </fg-input>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="text"
                        label="Motor"
                        :disabled="true"
                        v-model="car.info.engine_number">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="text"
                        label="Chasis"
                        :disabled="true"
                        v-model="car.info.chassis_number">
              </fg-input>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    props: {
      car: null,
      account: null,
    },

    methods: {
      input_changed: function (key, has_error) {
        this.$emit('input-changed', key, has_error)
      } 
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// CarProps.vue?b5dc77bc